import Vue from 'vue'
import Router from 'vue-router'

import OutLine from '@/components/outline'//走进西樵山首页
import SceneryInfoForJieSaho from '@/components/sceneryInfomationForjieshao'
import Culture from '@/components/Culture'

import Scenery from '@/components/scenery'
import SceneryInfo from '@/components/sceneryInfomation'




import History from '@/components/history'

import PlayAllOver from '@/components/PlayAllOver'//玩遍西樵山首页 1
import PlayAllOverForFood from '@/components/PlayAllOverForFood'//2
import PlayAllOverForLive from '@/components/PlayAllOverForLive'//3
import PlayAllOverForStudy from '@/components/PlayAllOverForStudy'//4
import PlayAllOverForBuy from '@/components/PlayAllOverForBuy'//5
import PlayAllOverForHappy from '@/components/PlayAllOverForHappy'//6

import sceneryInfomationForwanbian from '@/components/sceneryInfomationForwanbian'//食
import sceneryInfomationForwanbianLive from '@/components/sceneryInfomationForwanbianLive'//住
import sceneryInfomationForwanbianStudy from '@/components/sceneryInfomationForwanbianStudy'//学
import sceneryInfomationForwanbianBuy from '@/components/sceneryInfomationForwanbianBuy'//购
import sceneryInfomationForwanbianHappy from '@/components/sceneryInfomationForwanbianHappy'//乐

import InfomationAllOver from '@/components/InfomationAllOver'//活动回顾 - 讯游
import InfomationAllOverForWork from '@/components/InfomationAllOverForWork'//工作动态  - 讯游
import InfomationAllOverForNotion from '@/components/InfomationAllOverForNotion'//通知公告 - 讯游

import InfomationAllOverDetails from '@/components/InfomationAllOverDetails'//活动回顾详情 - 讯游
import InfomationAllOverForNotionDetails from '@/components/InfomationAllOverForNotionDetails'//工作动态详情  - 讯游
import InfomationAllOverForWorkDetails from '@/components/InfomationAllOverForWorkDetails'//通知公告详情 - 讯游

import BeautyAllOver from '@/components/BeautyAllOver'//醉美西樵山首页 1
import BeautyAllOverForMove from '@/components/BeautyAllOverForMove'//醉美西樵山  2
import BeautyAllOverForRadio from '@/components/BeautyAllOverForRadio'//醉美西樵山  3 
import BeautyAllOverFor720 from '@/components/BeautyAllOverFor720'//醉美西樵山  4     
import BeautyAllOverForBook from '@/components/BeautyAllOverForBook'//醉美西樵山  5  

import CleverAllOver from '@/components/CleverAllOver'//智游西樵山 通用页面

import FOUR from '@/components/404'//玩遍西樵山首页 1

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: 'cn',
  routes: [
    {
      path: '/',//1 -- 走进西樵山
      name: 'outline',
      component: OutLine
    },
    {
      path: '/scenery',//2
      name: 'scenery',
      component: Scenery
    },
    {
      path: '/Culture',//3
      name: 'Culture',
      component: Culture
    },
    {
      path: '/history',
      name: 'history',//4
      component: History
    },
    {
      path: '/sceneryInfoForjiesaho',
      name: 'sceneryInfoForjiesaho',//-- 走进西樵山 xq
      component: SceneryInfoForJieSaho
    },

    {
      path: '/InfomationAllOver',//讯游西樵山 - 活动回顾
      name: 'InfomationAllOver',
      component: InfomationAllOver
    },
    {
      path: '/InfomationAllOverForWork',//讯游西樵山 - 工作动态
      name: 'InfomationAllOverForWork',
      component: InfomationAllOverForWork
    },
    {
      path: '/InfomationAllOverForNotion',//讯游西樵山 - 通知公告
      name: 'InfomationAllOverForNotion',
      component: InfomationAllOverForNotion
    },


    {
      path: '/InfomationAllOverDetails',//讯游西樵山 - 活动回顾
      name: 'InfomationAllOverDetails',
      component: InfomationAllOverDetails
    },
    {
      path: '/InfomationAllOverForWorkDetails',//讯游西樵山 - 工作动态
      name: 'InfomationAllOverForWorkDetails',
      component: InfomationAllOverForWorkDetails
    },
    {
      path: '/InfomationAllOverForNotionDetails',//讯游西樵山 - 通知公告
      name: 'InfomationAllOverForNotionDetails',
      component: InfomationAllOverForNotionDetails
    },

    {
      path: '/PlayAllOver',//1 --玩遍西樵山 行
      name: 'PlayAllOver',
      component: PlayAllOver
    },
    {
      path: '/sceneryInfomationForwanbian',//--玩遍西樵山  行 详情
      name: 'sceneryInfomationForwanbian',
      component: sceneryInfomationForwanbian
    },
    {
      path: '/PlayAllOverForFood',//2 --玩遍西樵山 食
      name: 'PlayAllOverForFood',
      component: PlayAllOverForFood
    },
    {
      path: '/sceneryInfomationForwanbianLive',//--食  详情
      name: 'sceneryInfomationForwanbianLive',
      component: sceneryInfomationForwanbianLive
    },
    {
      path: '/PlayAllOverForLive',//3 --玩遍西樵山 住
      name: 'PlayAllOverForLive',
      component: PlayAllOverForLive
    },
    {
      path: '/sceneryInfomationForwanbianStudy',//--xue  详情
      name: 'sceneryInfomationForwanbianStudy',
      component: sceneryInfomationForwanbianStudy
    },
    {
      path: '/PlayAllOverForStudy',//4 --玩遍西樵山 学
      name: 'PlayAllOverForStudy',
      component: PlayAllOverForStudy
    },

    {
      path: '/sceneryInfomationForwanbianBuy',//--gou  详情
      name: 'sceneryInfomationForwanbianBuy',
      component: sceneryInfomationForwanbianBuy
    },
    {
      path: '/PlayAllOverForBuy',//5 --买
      name: 'PlayAllOverForBuy',
      component: PlayAllOverForBuy
    },
    {
      path: '/PlayAllOverForHappy',//6 --乐
      name: 'PlayAllOverForHappy',
      component: PlayAllOverForHappy
    },
    {
      path: '/sceneryInfomationForwanbianHappy',//--乐  详情
      name: 'sceneryInfomationForwanbianHappy',
      component: sceneryInfomationForwanbianHappy
    },
    {
      path: '/BeautyAllOver',//1 --醉美西樵山 揽胜
      name: 'BeautyAllOver',
      component: BeautyAllOver
    },
    {
      path: '/BeautyAllOverForMove',//2 --醉美西樵山 影音
      name: 'BeautyAllOverForMove',
      component: BeautyAllOverForMove
    },
    {
      path: '/BeautyAllOverForRadio',//3 --醉美西樵山 录音
      name: 'BeautyAllOverForRadio',
      component: BeautyAllOverForRadio
    },
    {
      path: '/BeautyAllOverFor720',//4 --醉美西樵山 720全景
      name: 'BeautyAllOverFor720',
      component: BeautyAllOverFor720
    },
    {
      path: '/BeautyAllOverForBook',//5 --醉美西樵山 电子书
      name: 'BeautyAllOverForBook',
      component: BeautyAllOverForBook
    },
    {
      path: '/CleverAllOver',//1 --智游西樵山 通用页面
      name: 'CleverAllOver',
      component: CleverAllOver
    },
    {
      path: '/sceneryInfo',
      name: 'sceneryInfo',
      component: SceneryInfo
    },
    {
      path: '/404',
      name: '404',
      component: FOUR
    },


  ]
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js